import {
  checkUsernameAvailability,
  createImageUpload,
  deleteImage,
  get,
  getByUsername,
  getPermissions,
  getStats,
  search,
  searchAccounts,
  setImage,
  setUsername,
  update,
} from "./endpoints";

export { service } from "./endpoints";
export {
  CheckUsernameAvailabilityQuery,
  CheckUsernameAvailabilityResponse,
  CreateImageUploadRequest,
  CreateImageUploadResponse,
  FoundAccount,
  IMAGE_UPLOAD_CONTENT_TYPES,
  IMAGE_UPLOAD_MAX_BYTES,
  ImageCrop,
  ImageRejection,
  ImageUpload,
  PermissionsResponse,
  ProfileIdParams,
  ProfileImageKindParams,
  ProfileResponse,
  ProfileStatsResponse,
  SearchAccountsQuery,
  SearchAccountsResponse,
  SearchProfilesQuery,
  SearchProfilesResponse,
  SetProfileImageRequest,
  SetUsernameRequest,
  SetUsernameResponse,
  UpdateProfileRequest,
  UploadId,
  UsernameNameResult,
  UsernameParams,
} from "./schemas";

export const contract = {
  get,
  byUsername: { get: getByUsername },
  update,
  search,
  accounts: { search: searchAccounts },
  stats: { get: getStats },
  permissions: { get: getPermissions },
  username: { set: setUsername },
  usernameAvailability: { get: checkUsernameAvailability },
  images: {
    set: setImage,
    delete: deleteImage,
    uploads: { create: createImageUpload },
  },
} as const;
